import { cn } from "@/lib/utils";

type FieldProps = {
  children: React.ReactNode;
  color?: "destructive";
  tip?: string;
} & React.ComponentPropsWithoutRef<"div">;

export const OrderFormField = ({ children, color, tip, className, ...props }: FieldProps) => {
  return (
    <div className={cn("flex flex-col gap-1", className)} {...props}>
      {children}

      {tip && (
        <span
          className={cn(
            "text-xs block",
            color === "destructive"
              ? "text-destructive"
              : "text-muted-foreground"
          )}
        >
          {tip}
        </span>
      )}
    </div>
  );
};
